import type { SVGProps } from 'react';
const SvgPacifier = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M18 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6c0 1.097.294 2.125.809 3.009-.409.038-.794.2-1.106.466L7.822 5.594a2.003 2.003 0 0 0-2.831 0L3.782 6.803a.501.501 0 0 0 0 .706l3.65 3.647-.859.859c-.344.344-.55.8-.581 1.284-.097 1.512-.972 2.7-1.991 2.7a3.964 3.964 0 0 0-2.847 1.191 3.97 3.97 0 0 0-1.153 2.866 3.973 3.973 0 0 0 1.175 2.769A3.978 3.978 0 0 0 3.945 24h.056a3.952 3.952 0 0 0 2.806-1.153A3.964 3.964 0 0 0 7.998 20c0-1.019 1.188-1.894 2.703-1.991a1.993 1.993 0 0 0 1.284-.581l.859-.859 3.647 3.647a.5.5 0 0 0 .706 0l1.206-1.206c.378-.378.584-.881.584-1.416a2 2 0 0 0-.584-1.416l-3.878-3.881c.275-.322.428-.709.466-1.106A5.98 5.98 0 0 0 18 12Zm0-11c2.756 0 5 2.244 5 5s-2.244 5-5 5-5-2.244-5-5 2.244-5 5-5Zm-7.428 15.013C7.966 16.182 6 17.897 6 20a1.997 1.997 0 0 1-2.031 2 2.016 2.016 0 0 1-1.972-1.972A1.996 1.996 0 0 1 4 18c2.103 0 3.819-1.966 3.987-4.572l.859-.859 2.587 2.584-.863.859.002.001Zm5.569 2.437L5.55 7.863l.856-.856L16.99 17.594l-.85.856h.001Zm-3.725-8.262a.995.995 0 0 1 1.29.106c.35.35.387.9.106 1.291l-1.397-1.397h.001Z"
      style={{
        fillRule: 'nonzero',
      }}
      transform="rotate(90 12 12)"
    />
    <path
      d="M18 10c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4Zm0-7c1.653 0 3 1.347 3 3s-1.347 3-3 3-3-1.347-3-3 1.347-3 3-3Z"
      style={{
        fillRule: 'nonzero',
      }}
      transform="rotate(90 12 12)"
    />
  </svg>
);
export default SvgPacifier;
